// extracted by mini-css-extract-plugin
module.exports = {"form-container":"formStyles_form-container__kfNee","fadeInUp":"formStyles_fadeInUp__qdESF"};